var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 221,
    viewBox: "0 0 200 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 214C155.228 214 200 169.228 200 114C200 58.7715 155.228 14 100 14C44.7715 14 0 58.7715 0 114C0 169.228 44.7715 214 100 214Z",
    fill: "#EBEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1421_39310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.334 71.332H42.6669C38.985 71.332 36.0002 74.3168 36.0002 77.9987V217.999C36.0002 221.681 38.985 224.665 42.6669 224.665H157.334C161.015 224.665 164 221.681 164 217.999V77.9987C164 74.3168 161.015 71.332 157.334 71.332Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6667 91.332H52C49.7909 91.332 48 93.1229 48 95.332C48 97.5412 49.7909 99.332 52 99.332H86.6667C88.8758 99.332 90.6667 97.5412 90.6667 95.332C90.6667 93.1229 88.8758 91.332 86.6667 91.332Z",
    fill: "#E0E0E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.667 108.664H52C49.7909 108.664 48 110.455 48 112.664C48 114.873 49.7909 116.664 52 116.664H110.667C112.876 116.664 114.667 114.873 114.667 112.664C114.667 110.455 112.876 108.664 110.667 108.664Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6667 127.332H52C49.7909 127.332 48 129.123 48 131.332C48 133.541 49.7909 135.332 52 135.332H86.6667C88.8758 135.332 90.6667 133.541 90.6667 131.332C90.6667 129.123 88.8758 127.332 86.6667 127.332Z",
    fill: "#E0E0E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.667 144.664H52C49.7909 144.664 48 146.455 48 148.664C48 150.873 49.7909 152.664 52 152.664H110.667C112.876 152.664 114.667 150.873 114.667 148.664C114.667 146.455 112.876 144.664 110.667 144.664Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6667 163.332H52C49.7909 163.332 48 165.123 48 167.332C48 169.541 49.7909 171.332 52 171.332H86.6667C88.8758 171.332 90.6667 169.541 90.6667 167.332C90.6667 165.123 88.8758 163.332 86.6667 163.332Z",
    fill: "#E0E0E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.667 180.664H52C49.7909 180.664 48 182.455 48 184.664C48 186.873 49.7909 188.664 52 188.664H110.667C112.876 188.664 114.667 186.873 114.667 184.664C114.667 182.455 112.876 180.664 110.667 180.664Z",
    fill: "#EBEBEB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1421_39310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.333 3.33203H42.6667C38.9848 3.33203 36 6.3168 36 9.9987V49.9987C36 53.6806 38.9848 56.6654 42.6667 56.6654H157.333C161.015 56.6654 164 53.6806 164 49.9987V9.9987C164 6.3168 161.015 3.33203 157.333 3.33203Z",
    fill: "#E0E0E1"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6664 18H51.9998C49.7906 18 47.9998 19.7909 47.9998 22C47.9998 24.2091 49.7906 26 51.9998 26H86.6664C88.8756 26 90.6664 24.2091 90.6664 22C90.6664 19.7909 88.8756 18 86.6664 18Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.666 35.332H51.9998C49.7906 35.332 47.9998 37.1229 47.9998 39.332C47.9998 41.5412 49.7906 43.332 51.9998 43.332H110.666C112.876 43.332 114.666 41.5412 114.666 39.332C114.666 37.1229 112.876 35.332 110.666 35.332Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1421_39310",
    x: 30.0002,
    y: 62.332,
    width: 140,
    height: 165.332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1421_39310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1421_39310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1421_39310",
    x: 30,
    y: 0.332031,
    width: 140,
    height: 65.332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1421_39310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1421_39310",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyLog);
export default __webpack_public_path__ + "static/media/empty-log.ccfc5fc47e1f8268777c26538869e61b.svg";
export { ForwardRef as ReactComponent };